import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  SelectInputComponent,
  NumberInputComponent,
} from '@navstation-portal/shared/ui/components';
import { SWELL_OPTIONS } from '@navstation-portal/reporting/data-access/vessel-report';
import { TIMEZONE_OPTIONS } from '@navstation-portal/shared/util/time';
import {
  AbstractStoreConnectedSectionComponent,
  offshorePositionAndWeatherEvents,
  OffshorePositionAndWeatherFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-currents-and-sea-water',
  templateUrl: './currents-and-sea-water.component.html',
  imports: [FormsModule, SelectInputComponent, NumberInputComponent],
})
export class CurrentsAndSeaWaterComponent extends AbstractStoreConnectedSectionComponent {
  swellOptions = SWELL_OPTIONS;
  timezoneOptions = TIMEZONE_OPTIONS;
  tabId = 'positionAndWeather';
  sectionId = 'currentsAndSeaWater';
  events = injectDispatch(offshorePositionAndWeatherEvents);
  positionAndWeatherStore = inject(OffshorePositionAndWeatherFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
